export default "__VITE_ASSET__CkLGajfi__"